import { Validators } from '@angular/forms';

export const twoFields = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username',
    validation: [Validators.required],
    icon: 'user',
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    label: 'Login',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];
